import { initBrowserObservability } from "./src/observability/browser";

initBrowserObservability();
